<template>
    <div class="relative flex flex-col flex-1 min-h-0 bg-stage-background overflow-hidden">
        <div class="px-8 sm:px-8 lg:px-8 pt-6 pb-3">
            <div class="flex items-center justify-between gap-4">
                <h1 class="text-2xl font-semibold text-gray-900 truncate">
                    {{ pageTitle }}
                </h1>
                <router-link
                    class="btn-stage-primary"
                    :to="'/workspace/tickets/' + $route.params.id + '/manage'"
                >
                    Zum Ticket
                </router-link>
            </div>
        </div>

        <div class="stage-page-gutters stage-page-fill pt-1">
            <div class="w-full h-full bg-white shadow sm:rounded border border-gray-200 flex flex-col min-h-0">
                <div v-if="loading" class="p-4 text-gray-500">JSON wird geladen...</div>

                <div v-else-if="error" class="p-4 text-red-600">{{ error }}</div>

                <div v-else class="p-4 flex-1 min-h-0">
                    <code-viewer
                        :code="prettyJson"
                        :fill="true"
                        language="json"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import CodeViewer from "@/components/ui/code-viewer";

export default {
    name: "WorkspaceTicketJson",
    components: {
        CodeViewer,
    },
    data() {
        return {
            loading: true,
            error: '',
            payload: null,
            ticketSubject: '',
        };
    },
    computed: {
        pageTitle() {
            const subject = (this.ticketSubject || '').trim();
            return subject !== '' ? `Ticket ${subject} (JSON)` : 'Ticket (JSON)';
        },
        prettyJson() {
            return this.payload ? JSON.stringify(this.payload, null, 2) : '';
        },
    },
    methods: {
        loadJson() {
            const self = this;
            self.loading = true;
            self.error = '';

            axios.get('api/workspace/tickets/' + self.$route.params.id + '/json')
                .then(function (response) {
                    self.payload = response.data;
                    self.ticketSubject = response && response.data && response.data.ticket
                        ? (response.data.ticket.subject || '')
                        : '';
                })
                .catch(function (error) {
                    self.payload = null;
                    self.ticketSubject = '';
                    const message = error && error.response && error.response.data && error.response.data.message
                        ? error.response.data.message
                        : 'Ticket JSON konnte nicht geladen werden.';
                    self.error = message;
                })
                .finally(function () {
                    self.loading = false;
                });
        },
    },
    mounted() {
        this.loadJson();
    },
    watch: {
        '$route.params.id': function () {
            this.loadJson();
        },
    },
    metaInfo() {
        return {
            title: this.pageTitle,
        };
    },
};
</script>
